import { useContext } from 'react';

import { UserPreferencesContext } from '../context/UserPreferencesContext';
import { UnitsOfMeasure } from '../types/Locations';

export interface UnitOfMeasurementSetter {
  (unitOfMeasurementCode: UnitsOfMeasure): void;
}

export function useUnitOfMeasurement(): [
  UnitsOfMeasure,
  UnitOfMeasurementSetter,
] {
  const { preferences, setUnitOfMeasurement } = useContext(
    UserPreferencesContext,
  );

  return [preferences.unitOfMeasurement, setUnitOfMeasurement];
}
